import { Component, OnInit, OnDestroy } from "@angular/core";
import { trigger, transition, style, animate } from "@angular/animations";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-home-carouselslidestep",
  templateUrl: "./home-carouselslidestep.component.html",
  styleUrls: ["./home-carouselslidestep.component.scss"],
  standalone: false,
  animations: [
    trigger("fadeSlideAnimation", [
      transition(":enter", [
        style({ opacity: 0, transform: "translateY(20px)" }),
        animate(
          "500ms ease-out",
          style({ opacity: 1, transform: "translateY(0)" })
        ),
      ]),
      transition(":leave", [
        animate(
          "500ms ease-out",
          style({ opacity: 0, transform: "translateY(-20px)" })
        ),
      ]),
    ]),
  ],
})
export class HomeCarouselslidestepComponent {
  currentIndex = 0;
  pageSize = 60;
  pageIndex = 0;
  constructor(
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {}
  steps = [
    {
      img: "assets/img/homeslide-step1.png",
      titleKey: "home.steps.step1.title",
      descKey: "home.steps.step1.description",
    },
    {
      img: "assets/img/homeslide-step2.png",
      titleKey: "home.steps.step2.title",
      descKey: "home.steps.step2.description",
    },
    {
      img: "assets/img/homeslide-step3.png",
      titleKey: "home.steps.step3.title",
      descKey: "home.steps.step3.description",
    },
  ];
  showSlide(index: number) {
    this.currentIndex = index;
  }
  intervalId: any;
  ngOnInit(): void {
    this.startAutoPlay();
  }

  ngOnDestroy(): void {
    this.stopAutoPlay();
  }
  startAutoPlay() {
    this.intervalId = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.steps.length;
    }, 5000);
  }

  stopAutoPlay() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
